import React from 'react';
import { SERVICE_DOMAIN } from '../../../s3-assets/ServiceDomain';

const HeroSection = () => {
  return (
    <section
      className="flex items-center justify-between py-16 px-8 bg-white bg-cover min-h-screen mt-[-6px] mb-16"
    >
      <div className="relative w-full md:w-1/2 flex justify-center">
        <img
          src={SERVICE_DOMAIN.IMAGE_1} alt="Aari Work Illustration"
          className="w-full max-w-md transform transition-transform duration-500 hover:scale-105 shadow-lg rounded-lg"
          style={{ perspective: '1000px', transformStyle: 'preserve-3d' }}
        />
      </div>

      <div className="w-full md:w-1/2 mt-8 md:mt-0 text-center md:text-left">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
          Best Aari Work Blouse Chennai
        </h1>
        <p className="text-gray-600 mb-6">
          Elevate your fashion with exquisitely designed Aari work blouses. Perfect craftsmanship tailored to your style.
        </p>
        <button
          className="bg-pink-600 text-white px-6 py-3 rounded-full shadow-lg transition hover:bg-pink-700 hover:shadow-xl"
        >
          Book Appointment
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
